/*eslint no-unused-vars: 0*/

import { fromJS, Map } from 'immutable';
import { createReducer } from '../../helpers/store';
import { AuthActionTypes } from './actions';
import { ProfileActionTypes } from '../profile/actions';
import {
  setSession,
  setUser,
  getSession,
  getIsAuthenticated,
  getUser,
  removeSession,
  removeUser
} from '../../helpers/auth';
import Segment from '../../helpers/segment';

const initialState = fromJS({
  session: getSession(),
  user: getUser(),
  isAuthenticated: getIsAuthenticated(),
  loginError: '',
  showLoginModal: false,
  showChangePasswordModal: false,
  passwordState: {
    msgClass: 'text-red',
    msg: ''
  }
});

const handleLoginRequest = (state, action) => {
  return state
    .set('session', fromJS({ isLoading: true }))
    .set('loginError', '');
};
const handleLoginFailure = (state, action) => {
  const loginError = 'Login failed. Please check your credentials.';

  Segment.track('Failed Login');

  return state
    .set('isAuthenticated', false)
    .set('session', fromJS({ loginError }))
    .set('loginError', loginError);
};
const handleLoginSuccess = (state, action) => {
  setSession(action.response.data);
  Segment.track('Logged In');
  return state
    .set('session', fromJS(action.response.data))
    .set('loginError', '')
    .set('showLoginModal', false)
    .set('isAuthenticated', true);
};

const handleLogout = (state, action) => {
  removeSession();
  removeUser();

  Segment.track('Logged Out');
  return state
    .delete('session')
    .delete('user')
    .set('isAuthenticated', false);
};

const handleUserLoadRequest = (state, action) => {
  return state.set('user', fromJS({ isLoading: true }));
};
const handleUserLoadFailure = (state, action) => {
  Segment.track('Failed to refresh user info');
  return state.set('user', fromJS({ errorMessage: action.error }));
};
const handleUserLoadSuccess = (state, action) => {
  setUser(action.response.data);

  const user = action.response.data;
  Segment.identify(user.email, {
    first_name: user.first_name,
    last_name: user.last_name
  });
  Segment.track('Refreshed User Info');
  return state.set('user', fromJS(user));
};

const handleForgotPasswordRequest = (state, action) => {
  return state
    .setIn(['passwordState', 'msg'], '')
    .setIn(['passwordState', 'msgClass'], 'text-red');
};
const handleForgotPasswordFailure = (state, action) => {
  Segment.track('Failed to Reset Password');
  return state
    .setIn(
      ['passwordState', 'msg'],
      `Sorry, we were unable to reset your password.`
    )
    .setIn(['passwordState', 'msgClass'], 'text-red');
};
const handleForgotPasswordSuccess = (state, action) => {
  Segment.track('Reset Password');
  return state
    .setIn(
      ['passwordState', 'msg'],
      'If this user exists, we have sent you password reset email.'
    )
    .setIn(['passwordState', 'msgClass'], 'text-green');
};

const handleChangePasswordRequest = (state, action) => {
  return state
    .setIn(['passwordState', 'msg'], '')
    .setIn(['passwordState', 'msgClass'], 'text-red');
};
const handleChangePasswordFailure = (state, action) => {
  Segment.track('Failed to Change Password');
  const msg =
    action.error.status === 403
      ? 'Incorrect password.'
      : 'Sorry, we were unable to change your password.';
  return state
    .setIn(['passwordState', 'msg'], msg)
    .setIn(['passwordState', 'msgClass'], 'text-red');
};
const handleChangePasswordSuccess = (state, action) => {
  Segment.track('Changed Password');
  return state
    .setIn(['passwordState', 'msg'], 'Your password has been updated.')
    .setIn(['passwordState', 'msgClass'], 'text-green');
};

const handleShowChangePasswordModal = (state, action) => {
  return state.set('showChangePasswordModal', action.show);
};

const handleShowLoginModal = (state, action) => {
  return state.set('showLoginModal', action.show);
};

export const authReducer = createReducer(initialState, {
  [AuthActionTypes.LOGIN_REQUEST]: handleLoginRequest,
  [AuthActionTypes.LOGIN_SUCCESS]: handleLoginSuccess,
  [AuthActionTypes.LOGIN_FAILURE]: handleLoginFailure,
  [AuthActionTypes.LOGOUT]: handleLogout,
  [AuthActionTypes.USER_LOAD_REQUEST]: handleUserLoadRequest,
  [AuthActionTypes.USER_LOAD_SUCCESS]: handleUserLoadSuccess,
  [ProfileActionTypes.UPDATE_PROFILE_SUCCESS]: handleUserLoadSuccess,
  [AuthActionTypes.USER_LOAD_FAILURE]: handleUserLoadFailure,
  [AuthActionTypes.FORGOT_PASSWORD_REQUEST]: handleForgotPasswordRequest,
  [AuthActionTypes.FORGOT_PASSWORD_SUCCESS]: handleForgotPasswordSuccess,
  [AuthActionTypes.FORGOT_PASSWORD_FAILURE]: handleForgotPasswordFailure,
  [AuthActionTypes.CHANGE_PASSWORD_REQUEST]: handleChangePasswordRequest,
  [AuthActionTypes.CHANGE_PASSWORD_SUCCESS]: handleChangePasswordSuccess,
  [AuthActionTypes.CHANGE_PASSWORD_FAILURE]: handleChangePasswordFailure,
  [AuthActionTypes.SHOW_CHANGE_PASSWORD_MODAL]: handleShowChangePasswordModal,
  [AuthActionTypes.SHOW_LOGIN_MODAL]: handleShowLoginModal
});



/** WEBPACK FOOTER **
 ** ./src/state/auth/reducer.js
 **/